"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const obstacleDuration_1 = __importDefault(require("../../constants/obstacleDuration"));
const obstacleInvincibleDuration_1 = __importDefault(require("../../constants/obstacleInvincibleDuration"));
const unitsPerTile_1 = __importDefault(require("../../constants/unitsPerTile"));
const CollisionType_1 = __importDefault(require("../../enums/CollisionType"));
const state_1 = __importDefault(require("../../state"));
const getAudioSource_1 = __importDefault(require("../definables/getAudioSource"));
const getTilemap_1 = __importDefault(require("../definables/getTilemap"));
const cootsMaxVelocity_1 = __importDefault(require("../../constants/cootsMaxVelocity"));
const updateCootsPosition = () => {
    const collisionVelocityFactor = -.7;
    const bonkThreshold = cootsMaxVelocity_1.default / unitsPerTile_1.default / 3;
    // Furniture
    const furnitureLeftOffset = -.4;
    const furnitureTopOffset = -.5;
    const furnitureBottomOffset = .85;
    const furnitureRightOffset = .9;
    const furnitureTopLeftCoords = {
        x: state_1.default.cootsCoords.x + furnitureLeftOffset * unitsPerTile_1.default,
        y: state_1.default.cootsCoords.y + furnitureTopOffset * unitsPerTile_1.default
    };
    const furnitureTopRightCoords = {
        x: furnitureTopLeftCoords.x + furnitureRightOffset * unitsPerTile_1.default,
        y: furnitureTopLeftCoords.y
    };
    const furnitureBottomLeftCoords = {
        x: furnitureTopLeftCoords.x,
        y: furnitureTopLeftCoords.y + furnitureBottomOffset * unitsPerTile_1.default
    };
    const furnitureBottomRightCoords = {
        x: furnitureTopRightCoords.x,
        y: furnitureBottomLeftCoords.y
    };
    const newX = state_1.default.cootsCoords.x + Math.floor(state_1.default.cootsVelocityX * (state_1.default.app.ticker.deltaMS / 1000));
    const newY = state_1.default.cootsCoords.y + Math.floor(state_1.default.cootsVelocityY * (state_1.default.app.ticker.deltaMS / 1000));
    const furnitureNewTopLeftCoords = {
        x: newX + furnitureLeftOffset * unitsPerTile_1.default,
        y: newY + furnitureTopOffset * unitsPerTile_1.default
    };
    const furnitureNewTopRightCoords = {
        x: furnitureNewTopLeftCoords.x + furnitureRightOffset * unitsPerTile_1.default,
        y: furnitureNewTopLeftCoords.y
    };
    const furnitureNewBottomLeftCoords = {
        x: furnitureNewTopLeftCoords.x,
        y: furnitureNewTopLeftCoords.y + furnitureBottomOffset * unitsPerTile_1.default
    };
    const furnitureNewBottomRightCoords = {
        x: furnitureNewTopRightCoords.x,
        y: furnitureNewBottomLeftCoords.y
    };
    const furnitureXCollision = [
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureNewTopLeftCoords.x, y: furnitureTopLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureNewBottomLeftCoords.x, y: furnitureBottomLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureNewTopRightCoords.x, y: furnitureTopRightCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureNewBottomRightCoords.x, y: furnitureBottomRightCoords.y })
    ];
    const furnitureYCollision = [
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureTopLeftCoords.x, y: furnitureNewTopLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureBottomLeftCoords.x, y: furnitureNewBottomLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureTopRightCoords.x, y: furnitureNewTopRightCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureBottomRightCoords.x, y: furnitureNewBottomRightCoords.y })
    ];
    const furnitureBothCollision = [
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureNewTopLeftCoords.x, y: furnitureNewTopLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureNewBottomLeftCoords.x, y: furnitureNewBottomLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureNewTopRightCoords.x, y: furnitureNewTopRightCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: furnitureNewBottomRightCoords.x, y: furnitureNewBottomRightCoords.y })
    ];
    // Obstacles
    const obstacleLeftOffset = 0;
    const obstacleTopOffset = 0;
    const obstacleBottomOffset = 0;
    const obstacleRightOffset = 0;
    const obstacleTopLeftCoords = {
        x: state_1.default.cootsCoords.x + obstacleLeftOffset * unitsPerTile_1.default,
        y: state_1.default.cootsCoords.y + obstacleTopOffset * unitsPerTile_1.default
    };
    const obstacleTopRightCoords = {
        x: obstacleTopLeftCoords.x + obstacleRightOffset * unitsPerTile_1.default,
        y: obstacleTopLeftCoords.y
    };
    const obstacleBottomLeftCoords = {
        x: obstacleTopLeftCoords.x,
        y: obstacleTopLeftCoords.y + obstacleBottomOffset * unitsPerTile_1.default
    };
    const obstacleBottomRightCoords = {
        x: obstacleTopRightCoords.x,
        y: obstacleBottomLeftCoords.y
    };
    const obstacleNewTopLeftCoords = {
        x: newX + obstacleLeftOffset * unitsPerTile_1.default,
        y: newY + obstacleTopOffset * unitsPerTile_1.default
    };
    const obstacleNewTopRightCoords = {
        x: obstacleNewTopLeftCoords.x + obstacleRightOffset * unitsPerTile_1.default,
        y: obstacleNewTopLeftCoords.y
    };
    const obstacleNewBottomLeftCoords = {
        x: obstacleNewTopLeftCoords.x,
        y: obstacleNewTopLeftCoords.y + obstacleBottomOffset * unitsPerTile_1.default
    };
    const obstacleNewBottomRightCoords = {
        x: obstacleNewTopRightCoords.x,
        y: obstacleNewBottomLeftCoords.y
    };
    const obstacleXCollision = [
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleNewTopLeftCoords.x, y: obstacleTopLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleNewBottomLeftCoords.x, y: obstacleBottomLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleNewTopRightCoords.x, y: obstacleTopRightCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleNewBottomRightCoords.x, y: obstacleBottomRightCoords.y })
    ];
    const obstacleYCollision = [
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleTopLeftCoords.x, y: obstacleNewTopLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleBottomLeftCoords.x, y: obstacleNewBottomLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleTopRightCoords.x, y: obstacleNewTopRightCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleBottomRightCoords.x, y: obstacleNewBottomRightCoords.y })
    ];
    const obstacleBothCollision = [
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleNewTopLeftCoords.x, y: obstacleNewTopLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleNewBottomLeftCoords.x, y: obstacleNewBottomLeftCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleNewTopRightCoords.x, y: obstacleNewTopRightCoords.y }),
        (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCollisionAtCoords({ x: obstacleNewBottomRightCoords.x, y: obstacleNewBottomRightCoords.y })
    ];
    // Checks
    const invincible = state_1.default.hasHitObstacleAt() && state_1.default.currentTime - state_1.default.hitObstacleAt < obstacleInvincibleDuration_1.default + obstacleDuration_1.default;
    if (invincible === false && obstacleXCollision.some((collision) => collision === CollisionType_1.default.Obstacle)) {
        state_1.default.hitObstacleAt = state_1.default.currentTime;
        (0, getAudioSource_1.default)("noises/meow").play(null, null);
    }
    else if (invincible === false && obstacleYCollision.some((collision) => collision === CollisionType_1.default.Obstacle)) {
        state_1.default.hitObstacleAt = state_1.default.currentTime;
        (0, getAudioSource_1.default)("noises/meow").play(null, null);
    }
    else if (invincible === false && obstacleBothCollision.some((collision) => collision === CollisionType_1.default.Obstacle)) {
        state_1.default.hitObstacleAt = state_1.default.currentTime;
        (0, getAudioSource_1.default)("noises/meow").play(null, null);
    }
    else if (furnitureXCollision.some((collision) => collision === CollisionType_1.default.Bonk)) {
        const bonkVelocity = Math.abs(state_1.default.cootsVelocityX) / unitsPerTile_1.default;
        if (bonkVelocity >= bonkThreshold) {
            (0, getAudioSource_1.default)("noises/bounce").play(null, null);
        }
        state_1.default.cootsVelocityX *= collisionVelocityFactor;
    }
    else if (furnitureYCollision.some((collision) => collision === CollisionType_1.default.Bonk)) {
        const bonkVelocity = Math.abs(state_1.default.cootsVelocityY) / unitsPerTile_1.default;
        if (bonkVelocity >= bonkThreshold) {
            (0, getAudioSource_1.default)("noises/bounce").play(null, null);
        }
        state_1.default.cootsVelocityY *= collisionVelocityFactor;
    }
    else if (furnitureBothCollision.some((collision) => collision === CollisionType_1.default.Bonk)) {
        const bonkVelocity = Math.abs((state_1.default.cootsVelocityX + state_1.default.cootsVelocityY) / 2) / unitsPerTile_1.default;
        if (bonkVelocity >= bonkThreshold) {
            (0, getAudioSource_1.default)("noises/bounce").play(null, null);
        }
        state_1.default.cootsVelocityX *= collisionVelocityFactor;
        state_1.default.cootsVelocityY *= collisionVelocityFactor;
    }
    else {
        state_1.default.cootsCoords = { x: newX, y: newY };
    }
};
exports.default = updateCootsPosition;
